export default "__VITE_ASSET__C68QOK$c__"